//配置环境
var CONFIG = {
	name: "长春市大众物流装配有限责任公司",
	powerby: "长春市大众物流装配有限责任公司", 
	// powerby: "吉林省新舟智能科技有限公司", 
	baseURL: process.env.NODE_ENV == "development" ?
		"http://www.dzwlzpgs.com" : process.env.VUE_APP_ENV_DESC && process.env.VUE_APP_ENV_DESC == "test" ? // 开发
		"2" : // 测试
		"3", // 正式
	tel: '0431-85742088',
	address: '长春市高新技术开发区蔚山路5555号',
	e_mail: 'ccdzwlzpgs@ccdzwlzpgs.com',
	
	// 阿里云：IP及账号
	// 39.98.137.199
	// Administrator
	// JLxzznkj@2020

	// 写死的一些数据

	//供应链服务

	GYLFW: [{
			title: '仓储业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/F4B4DCCEE1DC93BC23CECB2AF31A3B02.jpg',
			html: `
				<p style="text-align:center">仓储业务  现场图01</p>
			`
		},
		{
			title: '仓储业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/77CE056BDC1EB18E7972E39BB6898E29.jpg',
			html: `
				<p style="text-align:center">仓储业务  现场图02</p>
			`
		},
		{
			title: '仓储业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/FE39C903A6F21906EEF5394126107F99.jpg',
			html: `
				<p style="text-align:center">仓储业务  现场图03</p>
			`
		},
		{
			title: '配送业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/922C802762127B150B7E6E19A9A2ACED.jpg',
			html: `
				<p style="text-align:center">配送业务 现场图01</p>
			`
		},
		{
			title: '配送业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/ED1C391DAD26E2C3658754DC97E31691.JPG',
			html: `
				<p style="text-align:center">配送业务 现场图02</p>
			`
		},
		{
			title: '配送业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/BBB21A5A4830A04DF441C9CFE0993ACB.JPG',
			html: `
				<p style="text-align:center">配送业务 现场图03</p>
			`
		},
		{
			title: '运输业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/A31323D3D443C866BAEAB3E1C7AF06D3.jpg',
			html: `
				<p style="text-align:center">运输业务 现场图01</p>
			`
		},
		{
			title: '运输业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/69A87E053DC651EE2C4444893AACDC3C.jpg',
			html: `
				<p style="text-align:center">运输业务 现场工作图02</p>
			`
		},
		{
			title: '运输业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/E0FABB64C624B952446A209947FE68E8.JPG',
			html: `
				<p style="text-align:center">运输业务 现场图03</p>
			`
		},
		// {
		// 	title: '装配业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/F1052CEAB02F51E2BAE440AD56187583.png',
		// 	html: `
		// 		<p style="text-align:center">生产线装配业务 现场工作图01</p>
		// 	`
		// },
		{
			title: '装配业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/3CD66BFD03C0785E11623404E9CEDFC5.JPG',
			html: `
				<p style="text-align:center">生产线装配业务 现场工作图01</p>
			`
		},
		{
			title: '装配业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/EDD148F363AF51EFFECF8B4F5EDE6850.JPG',
			html: `
				<p style="text-align:center">生产线装配业务 现场工作图02</p>
			`
		},
		{
			title: '装配业务',
			date: '2021/02/09',
			// img: 'http://www.dzwlzpgs.com/Upload/news/182F0E37CA2ABBF4F57547577F58250E.JPG',
			html: `
				<p style="text-align:center">生产线装配业务 现场工作图03</p>
			`
		},
		// {
		// 	title: '装配业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/9758BA39ADD78B45E7C7B7CB15A629B5.JPG',
		// 	html: `
		// 		<p style="text-align:center">生产线装配业务 现场工作图05</p>
		// 	`
		// },
		// {
		// 	title: '装配业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/407B1B7A7EACA47DB5C9120C2D64B5E3.JPG',
		// 	html: `
		// 		<p style="text-align:center">生产线装配业务 现场工作图06</p>
		// 	`
		// },
		// {
		// 	title: '配送业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/071E4DDFAFD1F37F7653D8E063487805.png',
		// 	html: `
		// 		<p style="text-align:center">零件配送业务 现场工作图01</p>
		// 	`
		// },
		// {
		// 	title: '配送业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/367EAD2D90D3791A2D6D4B7FF306D2E7.JPG',
		// 	html: `
		// 		<p style="text-align:center">零件配送业务 现场图03</p>
		// 	`
		// },
		// {
		// 	title: '配送业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/E67A2242892E614CBA1FDF3FF6B6652A.JPG',
		// 	html: `
		// 		<p style="text-align:center">零件配送业务 现场图04</p>
		// 	`
		// },
		// {
		// 	title: '仓储业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/0B3187D29EB7EE807CDFA2D0B511D525.jpg',
		// 	html: `
		// 		<p style="text-align:center">仓储业务  现场图02</p>
		// 	`
		// },
		// {
		// 	title: '仓储业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/D0CFB8A271F88566EABF8018A5660A29.jpg',
		// 	html: `
		// 		<p style="text-align:center">仓储业务 现场图04</p>
		// 	`
		// },
		// {
		// 	title: '仓储业务',
		// 	date: '2021/02/09',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/BA4A74448D88A39E266DFF1459D45EBD.JPG',
		// 	html: `
		// 		<p style="text-align:center">仓储业务  现场图04</p>
		// 	`
		// }

	],

	//智慧物流软件开发

	ZHWLRJKF: [{
			title: 'WMS系统',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/DB45863469F0C7730E068A87B3828165.jpg',
			html: `
				<p><strong>产品简介</strong><br>
				提升仓库作业效率、提高库存准确率、提升库存周转效率，提供透明化、实时化、可视化的仓库管理体验。</p>
				
				<p>为企业解决以下问题：<br>
				(1)&nbsp; 提升业务单元间信息传送和分享的快速性与可靠性；<br>
				(2)&nbsp; 规范业务流程，作业过程构建追溯到收集，创建追溯到机制；<br>
				(3)&nbsp; 提升现场管理的时效性、针对性、透明性；<br>
				(4)&nbsp; 增加人工操作者，提升信息反馈效率；<br>
				(5)&nbsp; 减少统计资料的陈旧、差错、遗漏，提升数据统计分析水平；<br>
				(6)&nbsp; 提升系统处置效率，防止人工重复的数据录入。</p>
			`
		},
		{
			title: 'WMS系统PDA端',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/AF59D29982B64C0FC8F1556A8F764E5C.jpg',
			html: `
				<p><strong>产品简介</strong><br>
				手持设备操作，让盘点更轻松。扫描后自动将库存信息实时上传，省去了手工录入和统计库存的工作。</p>
				
				<p>为企业解决以下问题：<br>
				(1)&nbsp; 提升业务单元间信息传送和分享的快速性与可靠性；<br>
				(2)&nbsp; 规范业务流程，作业过程构建追溯到收集，创建追溯到机制；<br>
				(3)&nbsp; 提升现场管理的时效性、针对性、透明性；<br>
				(4)&nbsp; 增加人工操作者，提升信息反馈效率；<br>
				(5)&nbsp; 减少统计资料的陈旧、差错、遗漏，提升数据统计分析水平；<br>
				(6)&nbsp; 提升系统处置效率，防止人工重复的数据录入。</p>
			`
		},
		{
			title: '入场车控系统',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/B38511AFDE172314350444149DCE899A.jpg',
			html: `
				<p><strong>产品简介</strong><br>
				与WMS系统联动，统一信息化平台管理；物流管理规范化；卸货位管理智能化；提高物流运营效率。<br></p>
				<p>管理者可以在图像可视化界面清楚地看到码头的使用状态、司机进场离场时间、承运车辆的预约计划，将整个仓库的进出作业都形象地展现在眼前，厂内物流信息变得更加透明具体，提高运营效率。<br>
				另外，通过微信平台为入口，仓管人员、承运司机等终端用户均可以使用码头预约服务，用户注册与审批比较便捷，能轻松上手。</p>
			`
		},
		{
			title: 'TMS运输管理系统',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/F0AC08131483BB081BCE2A617FEFF655.jpg',
			html: `
				<p><strong>产品简介</strong><br>
				基于运输协同设计，实现供应链物流运力资源的合理配置、动态跟踪和作业任务的全程监控。全程对接手机移动端（包括货主、司机、调zhi度管理员、承运商等角色）、GPS硬件接入。从任务派遣、过程监管执行、交付签收、收付款结算全程管理。将货运环节中的制造商、承运商、司机和收货方链接在同一平台，轻松管理您的运输。</p>
				
				<p>帮您解决：服务商管理不到位，成本价格记错，不同服务商不同价位，货物类目多、运输方式不同、单号跟踪难等等一系列问题。<br>
				让人员配备更到位，人尽其职，物尽其用，合理分配资源，让企业管理更轻松，物流跟踪更准确。</p>
			`
		},
		{
			title: '结算管理系统',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/BFC9626992284155596EE248D35B8357.jpg',
			html: `
				<p><strong>产品简介</strong><br>
				为企业带来高效、便捷、无纸化的结算作业，实现财务业务一体化、财务结算跟踪可视化、结算全流程减少人工干预，从前端业务到财务核算全链条完整化。</p>
				
				<p>为企业解决以下问题：<br>
				1. 便于管理账务数据处理中从原始凭证到账簿的管理。<br>
				2. 通过严密的内部控制制度规范账务流程。<br>
				3.对物流行业定制，可以与WMS系统集成，实现数据的统一管理<br>
				4.实现机构的信息化和无纸化办公。</p>
			`
		},
		{
			title: '定制智慧物流软件开发',
			date: '2019/02/14',
			// img: 'http://www.dzwlzpgs.com/Upload/news/F0C4A9278F3E9AF60B379E172C29EE82.jpg',
			html: `
				<p><strong>产品简介</strong><br>
				为客户提供软件开发、信息化解决方案设计、企业管理模式设计、业务流程重组等服务，帮助客户实现全面数字化与网络化。</p>
				
				<p>订制化软件：<br>
				1.可以减少企业运营成本，增加收入：订制化软件操作方便，不需要多余的人力物力。<br>
				2.订制化软件为物流企业提供便捷的服务，提高员工的工作效率。<br>
				3.可以改善用户体验：客户可通过软件方便的进行业务沟通，并确保及时得到响应。</p>
			`
		}
	],

	//智能装备制造与集成

	ZNZBZZYJC: [{
			title: '牵引式AGV',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/7F3C6A51E5CFE244E9101C16A5B4D37A.png',
			html: `
				<p><strong>产品优势</strong><br>
				&nbsp; &nbsp; 全金属罩壳，坚固可靠。<br>
				&nbsp; &nbsp; 大容量锂电，超长续航时间，自动充电系统，快速充电。<br>
				&nbsp; &nbsp; 选用<span style="font-family:微软雅黑">德国SICK 激光雷达，提供更高定位</span>精度(士4mm)。</p>
				<p><strong>技术特点</strong><br>
				&nbsp; &nbsp; 无需<span style="font-family:微软雅黑">地面施工，减少现场破坏</span>。<br>
				&nbsp; &nbsp; 模拟真实人工作业，完美替代传统叉车。<br>
				&nbsp; &nbsp; 三重安全防护，有效杜绝安全事故可定制的车体，满足各种工作场景需求。<br>
				&nbsp; &nbsp; 开放的控制接口，可对接各类上层软件。</p>
				<p><strong>牵引车AGV系统参数：</strong></p>
				<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
					<tbody>
						<tr>
							<td style="width:300px">
							<p style="text-align:center"><strong>参数</strong></p>
							</td>
							<td style="width:300px">
							<p style="text-align:center"><strong>参数值</strong></p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">型号</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">QYC30A</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">外形尺寸</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1606*1020*2575mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center"><span style="font-size:12px">车自</span>重</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">880kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最小转弯半径</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1310</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">定位精度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">±5mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运行速度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1.2m/s</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运载类型</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">牵引拖挂式</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">牵引负载能力</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">3000KG</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">导航方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光导航</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">充电方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">自动/手动</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">锂电池容量</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">300AH/24V（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">安全系统</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光避障 安全触边</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">报警形式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">声光报警</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">驱动方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">舵轮驱动</p>
							</td>
						</tr>
					</tbody>
				</table>
				<p>&nbsp;</p>
			`
		},
		{
			title: '牵引式AGV',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/ACEE347E8ECEF7FBFF43FA561E929155.png',
			html: `
				<p><strong>产品优势</strong><br>
				&nbsp; &nbsp; 全金属罩壳，坚固可靠。<br>
				&nbsp; &nbsp; 大容量锂电，超长续航时间，自动充电系统，快速充电。<br>
				&nbsp; &nbsp; 选用德国SICK 激光雷达，提供更高定位精度(士4mm)。</p>
				<p><strong>技术特点</strong><br>
				&nbsp; &nbsp; 无需地面施工，减少现场破坏。<br>
				&nbsp; &nbsp; 模拟真实人工作业，完美替代传统叉车。<br>
				&nbsp; &nbsp; 三重安全防护，有效杜绝安全事故可定制的车体，满足各种工作场景需求。<br>
				&nbsp; &nbsp; 开放的控制接口，可对接各类上层软件。</p>
				<p><strong>牵引式AGV产品参数：</strong></p>
				<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
					<tbody>
						<tr>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数</strong></h2>
							</td>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数值</strong></h2>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">型号</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">QYC30A</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">外形尺寸</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1606*1020*2575mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">车自重</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">880kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最小转弯半径</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1310</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">定位精度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">±5mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运行速度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1.2m/s</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运载类型</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">牵引拖挂式</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">牵引负载能力</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">3000KG</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">导航方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光导航</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">充电方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">自动/手动</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">锂电池容量</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">300AH/24V（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">安全系统</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光避障 安全触边</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">报警形式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">声光报警</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">驱动方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">舵轮驱动</p>
							</td>
						</tr>
					</tbody>
				</table>
				<p>&nbsp;</p>
			`
		},
		{
			title: '叉车式AGV（搬运型）',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/6487A61C06E54CC86AFCC68F176E02ED.jpg',
			html: `
				<p><strong>产品优势</strong><br>
				&nbsp; &nbsp; <span style="font-family:微软雅黑">全金属罩壳，坚固可靠。<br>
				&nbsp; &nbsp; 大容量锂电，超长续航时间，自动充电系统，快速充电。<br>
				&nbsp; &nbsp; 可定制不同尺寸的货叉，适应各类工况。<br>
				&nbsp; &nbsp; 选用德国SICK 激光雷达，提供更高定位精度(士4mm)。</span></p>
				<p><strong>技术特点</strong><br>
				&nbsp; &nbsp; 无需地面施工，减少现场破坏。<br>
				&nbsp; &nbsp; 模拟真实人工作业，完美替代传统叉车。<br>
				&nbsp; &nbsp; 三重安全防护，有效杜绝安全事故可定制的车体，满足各种工作场景需求。<br>
				&nbsp; &nbsp; 开放的控制接口，可对接各类上层软件。</p>
				<p><strong>搬运式AGV（搬运型）产品参数：</strong></p>
				<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
					<tbody>
						<tr>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数</strong></h2>
							</td>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数值</strong></h2>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">型号</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">BYC30A</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最大提升高度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">200mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">外形尺寸</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">2155*1081*2350mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">车自重</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1030kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最小转弯半径</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1960mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">定位精度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">±5mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运行速度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1.2m/s</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运载类型</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">货叉举升式</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">负载能力</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">3000KG</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">导航方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光导航</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">充电方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">自动/手动</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">锂电池容量</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">300AH/24V（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">安全系统</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光避障 安全触边</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">报警形式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">声光报警</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">驱动方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">舵轮驱动</p>
							</td>
						</tr>
					</tbody>
				</table>
				<p>&nbsp;</p>
			`
		},
		{
			title: '潜伏式顶升车',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/DB3BC13D0EBAD258493CD0A74E6FFAD7.png',
			html: `
				<p><strong>产品优势</strong><br>
				&nbsp; &nbsp; <span style="font-family:微软雅黑">全金属罩壳，坚固可靠。<br>
				&nbsp; &nbsp; 大容量锂电，超长续航时间，自动充电系统，快速充电。<br>
				&nbsp; &nbsp; 提供高定位精度。</span></p>
				<p><strong>技术特点</strong><br>
				&nbsp; &nbsp; <span style="font-family:微软雅黑">基于惯性二维码导航技术，实现快递物料的全自动配送。<br>
				&nbsp; &nbsp; 智能控制系统实现多车调度，可与MES、WMS系统对接。<br>
				&nbsp; &nbsp; 多重安全传感器防护，保障AGV运行的安全性。<br>
				&nbsp; &nbsp; 显示操作终端查看AGV运行状态，方便客户进行故障诊断。</span></p>
				<p><strong>潜伏式顶升车AGV产品参数：</strong></p>
				<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
					<tbody>
						<tr>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数</strong></h2>
							</td>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数值</strong></h2>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">型号</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">QFJS4A</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">外形尺寸</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">984*674*325mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">车自重</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">230Kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最小转弯半径</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">0mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">定位精度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">±5mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运行速度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1.2m/s</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">行走方向</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">双向</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运载类型</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">潜伏举升式</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">负载能力</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">400Kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">导航方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">二维码导航</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">充电方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">自动/手动</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">锂电池容量</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">50AH/48V（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">安全系统</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光避障 安全触边</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">报警形式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">声光报警</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">驱动方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">双轮差速驱动</p>
							</td>
						</tr>
					</tbody>
				</table>
				
				<p>&nbsp;</p>
			`
		},
		{
			title: '二维码背负辊筒AGV',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/7C823B42AA2C9F80AE73B18BCD3C4C2D.png',
			html: `
				<p><strong>产品特点</strong><br>
				<span style="font-family:微软雅黑">&nbsp; 搬运速度快且稳，使零部件可快速、精确地运行。可多台AGV配合使用组成装配线，代替流水线，形成柔性生产系统。</span></p>
				<p><strong>二维码背负辊筒AGV产品参数：</strong></p>
				<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
					<tbody>
						<tr>
							<td style="width:300px">
							<p style="text-align:center"><strong>参数</strong></p>
							</td>
							<td style="width:300px">
							<p style="text-align:center"><strong>参数值</strong></p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">型号</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">BFGT1A</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">外形尺寸</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">984*674*450mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">车自重</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">210kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最小转弯半径</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">0mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">定位精度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">±5mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运行速度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1.2m/s</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">行走方向</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">双向</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运载类型</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">背负承载式</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">负载能力</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">100kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">导航方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">二维码导航</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">充电方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">自动/手动</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">锂电池容量</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">50AH/48V（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">安全系统</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光避障 安全触边</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">报警形式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">声光报警</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">驱动方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">双轮差速驱动</p>
							</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '叉车式AGV（平衡重型）',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/46361740F151F5C3C062C4689B394025.png',
			html: `
				
				<p><strong>产品优势</strong><br>
				&nbsp; &nbsp; <span style="font-family:微软雅黑">全金属罩壳，坚固可靠。<br>
				&nbsp; &nbsp; 288AH大容量锂电，超长续航时间100A自动充电系统，快速充电。<br>
				&nbsp; &nbsp; 可定制不同尺寸的货叉，适应各类工况。<br>
				&nbsp; &nbsp; 选用德国SICK 激光雷达，提供更高定位精度(士4mm)。</span></p>
				
				<p><strong>技术特点</strong><br>
				&nbsp; &nbsp; <span style="font-family:微软雅黑">无需地面施工，减少现场破坏。<br>
				&nbsp; &nbsp; 模拟真实人工作业，完美替代传统叉车。<br>
				&nbsp; &nbsp; 三重安全防护，有效杜绝安全事故可定制的车体，满足各种工作场景需求。<br>
				&nbsp; &nbsp; 开放的控制接口，可对接各类上层软件。</span></p>
				<p><strong>叉车式AGV(平衡重型)产品参数：</strong></p>
				
				<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
					<tbody>
						<tr>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数</strong></h2>
							</td>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数值</strong></h2>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">型号</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">QYS05L</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最大提升高度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">2000mm（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">外形尺寸</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">3637*1220*2100mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">车自重</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">2800kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最小转弯半径</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">2300mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">定位精度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">±5mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运行速度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1.2m/s</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运载类型</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">货叉举升式</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">负载能力</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">500KG</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">导航方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光导航</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">充电方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">自动/手动</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">锂电池容量</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">300AH/48V（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">安全系统</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光避障 安全触边</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">报警形式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">声光报警</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">驱动方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">舵轮驱动</p>
							</td>
						</tr>
					</tbody>
				</table>
				
				<p>&nbsp;</p>
			`
		},
		{
			title: '叉车式AGV（堆垛车型）',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/2738C117A80F67D479833E5204BF372C.png',
			html: `
				<p><strong>产品优势</strong><br>
				&nbsp; &nbsp; <span style="font-family:微软雅黑">全金属罩壳，坚固可靠。<br>
				&nbsp; &nbsp; 200AH大容量锂电，超长续航时间100A自动充电系统，快速充电。<br>
				&nbsp; &nbsp; 可定制不同尺寸的货叉，适应各类工况。<br>
				&nbsp; &nbsp; 选用德国SICK 激光雷达,提供更高定位精度(士4mm)。</span></p>
				<p><strong>技术特点</strong><br>
				&nbsp; &nbsp; <span style="font-family:微软雅黑">无需地面施工，减少现场破坏。<br>
				&nbsp; &nbsp; 模拟真实人工作业，完美替代传统叉车。<br>
				&nbsp; &nbsp; 三重安全防护，有效杜绝安全事故可定制的车体，满足各种工作场景需求。<br>
				&nbsp; &nbsp; 开放的控制接口，可对接各类上层软件。</span></p>
				<p><strong>叉车式AGV(堆垛车型)产品参数：</strong></p>
				
				<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
					<tbody>
						<tr>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数</strong></h2>
							</td>
							<td style="width:300px">
							<h2 style="text-align:center"><strong>参数值</strong></h2>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">型号</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">DGC15A</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最大提升高度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">2912mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">外形尺寸</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">2211*1007*2480mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">车自重</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1300kg</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">最小转弯半径</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1800mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">定位精度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">±5mm</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运行速度</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1.2m/s</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">运载类型</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">货叉举升式</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">负载能力</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">1500KG</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">导航方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光导航</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">充电方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">自动/手动</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">锂电池容量</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">300AH/24V（可定制）</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">安全系统</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">激光避障 安全触边</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">报警形式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">声光报警</p>
							</td>
						</tr>
						<tr>
							<td style="width:300px">
							<p style="text-align:center">驱动方式</p>
							</td>
							<td style="width:300px">
							<p style="text-align:center">舵轮驱动</p>
							</td>
						</tr>
					</tbody>
				</table>
				<p>&nbsp;</p>
			`
		},
		// {
		// 	title: '背负式辊筒车',
		// 	date: '2021/01/05',
		// 	// img: 'http://www.dzwlzpgs.com/Upload/news/3481F8B8087A0E35E0339EAEE5F45F9A.png',
		// 	html: `

		// 		<p><strong>产品优势</strong><br>
		// 		&nbsp; &nbsp; <span style="font-family:微软雅黑">全金属罩壳，坚固可靠。<br>
		// 		&nbsp; &nbsp; 大容量锂电，超长续航时间，自动充电系统，快速充电。<br>
		// 		&nbsp; &nbsp; 提供高定位精度。</span></p>

		// 		<p><strong>技术特点</strong><br>
		// 		&nbsp; &nbsp; <span style="font-family:微软雅黑">体积小巧、搬运灵活。<br>
		// 		&nbsp; &nbsp; 可与多台AGV无人搬运车配合使用时可组成装配线，代替流水线，形成柔性生产系统。<br>
		// 		&nbsp; &nbsp; AGV车体上放置托盘、料架、料箱等货物进行搬运，或在AGV尾部牵引料车。<br>
		// 		&nbsp; &nbsp; 背负式AGV小车搬运速度快且稳，使零部件可快速、精确地运行。</span></p>
		// 		<p><strong>背负式辊筒车AGV产品参数：</strong></p>

		// 		<table style="margin:0 auto; width:600px" cellspacing="0" border="1">
		// 			<tbody>
		// 				<tr>
		// 					<td style="width:300px">
		// 					<h2 style="text-align:center"><strong>参数</strong></h2>
		// 					</td>
		// 					<td style="width:300px">
		// 					<h2 style="text-align:center"><strong>参数值</strong></h2>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">型号</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">BFGT9B</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">外形尺寸</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">2090*1525*1425mm</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">车自重</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">750Kg</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">最小转弯半径</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">1900mm</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">定位精度</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">±5mm</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">运行速度</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">1.2m/s</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">运载类型</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">背负承载式</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">负载能力</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">900Kg</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">导航方式</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">激光导航</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">充电方式</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">自动/手动</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">锂电池容量</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">300AH/24V（可定制）</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">安全系统</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">激光避障 安全触边</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">报警形式</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">声光报警</p>
		// 					</td>
		// 				</tr>
		// 				<tr>
		// 					<td>
		// 					<p style="text-align:center">驱动方式</p>
		// 					</td>
		// 					<td>
		// 					<p style="text-align:center">舵轮驱动</p>
		// 					</td>
		// 				</tr>
		// 			</tbody>
		// 		</table>

		// 		<p>&nbsp;</p>
		// 	`
		// },
		{
			title: 'AGV手持智能终端',
			date: '2020/12/11',
			// img: 'http://www.dzwlzpgs.com/Upload/news/CAD9C54D8D9D6AB710A224D441269323.jpg',
			html: `
				<p>&nbsp; &nbsp; 包括系统配置、任务管理、拥塞控制和实时监控等关键模块，可以对AGV协同控制和管理，实现动态任务调度、任务呼叫以及与ERP、WMS及PLC等自动化设备接口，是智能物流系统的重要组成部分。<br>
				&nbsp; &nbsp; 除了可以完成地图定义、路径配置、任务管理等基本的导航与自动化运输任务下发功能，还可以进行多机协同管理和拥塞控制，完成复杂的调度任务，发挥AGV移动导航车与自动化设备、各种呼叫终端、工位及人员等系统化的整体效能，是企业智能物流系统、柔性制造系统的重要组成部分。</p>
			`
		},
		{
			title: '自动化立体仓库',
			date: '2019/03/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/28F2299DDD094F77588C758ADD3C8EF1.jpg',
			html: `
				<p><strong>自动化立体仓库</strong></p>
				<p>系统主体由货架，巷道式堆垛起重机、入(出)库工作台和自动运进(出)及操作控制系统组成。货架是钢结构或钢筋混凝土结构的建筑物或结构体，货架内是标准尺寸的货位空间；巷道堆垛起重机穿行于货架之间的巷道中，完成存、取货的工作。管理上采用计算机及条形码技术。配合储存信息管理系统，能够合理有效地进行库存控制，减少了货物处理和信息处理过程的差错，便于实现系统的整体优化。</p>
				<p><strong>产品特点</strong></p>
				<p>可实现仓库高层合理化，存取自动化，操作简便化。</p>
			`
		}
	],

	//公司动态

	newsList: [
		// 20220312+
		{
			title: '我司旗下裕新科技顶升式 AGV 锡柴联合测试成功',
			date: '2022/03/10',
			descr: '我司全资子公司裕新智能科技有限公司的智能设备新产品激光slam导航潜伏顶升式AGV/AMR，已经于近日在锡柴车间现场联合测试成功。',
			html: `
				<p>我司全资子公司裕新智能科技有限公司的智能设备新产品激光slam导航潜伏顶升式AGV/AMR，已经于近日在锡柴车间现场联合测试成功。</p>
				<p>本次9台智能设备的联合测试取得成功，标志着裕新公司AGV/AMR规划实施能力更上一个台阶。</p>
				<p>裕新公司的智能设备一定能助力主机厂实现机器换人、降本增效。</p>
			`,
			img_index: [15],
			video_index: [15]
		},
		{
			title: '大众物流全资子公司裕新智能科技成功入选 “2021中国工业应用移动机器人经典案例奖”',
			date: '2021/12/22',
			descr: '12月15-17日，2021中国移动机器人（AGV/AMR）行业发展年会在京召开，大众物流全资子公司裕新智能科技以创新的机器人产品、出色的项目落地应用能力再登行业榜单，荣获“2021中国工业应用移动机器人经典工程案例奖”',
			html: `
				<p>12月15-17日，2021中国移动机器人（AGV/AMR）行业发展年会在京召开，大众物流全资子公司裕新智能科技以创新的机器人产品、出色的项目落地应用能力再登行业榜单，荣获“2021中国工业应用移动机器人经典工程案例奖”</p>
				<p>此次共有31家企业31个案例获奖，涵盖了汽车汽配、工程机械、轮胎、3C电子、医药医疗等众多行业，无论是产品的创新度还是技术实力都有较高的代表性。</p>
				<p>获奖项目案例：该项目客户为国内某知名商用车生产厂，其总装车间预装产线采用SPS物流模式生产。项目接洽初期客户仅仅是希望用AGV替代人工开车完成配送任务。经过裕新智能的物流规划专家通过现场实景考察、调研、提炼数据信息，结合自身能力和AGV的前沿技术。从配货、叫料、信息系统对接、自动化设备应用、任务拆解与合并、拥堵智能避让、前瞻性AGV路线均衡分配、停线风险诱因分析等8处着手。为甲方提出了一套完整的、建设性的系统解决方案。且在较短的时间内完成了实施并将项目投入使用中。SPS料车上、下线环节融合自动化设备，实现了配送过程的无人化；不仅完全替代了人工驾车投料的传统作业模式，还对配货环节进行模式创新再造。有效降低了物料占地面积，降低了库内相应配货区作业人员的劳动强度。超额完成了机器换人的目的，真正实现了整体物流的自动化、信息化、智能化。</p>
				<p>在未来大众物流及裕新智能科技将继续努力，携手更多坚实的合作伙伴，在产品创新、服务创新等方面展开深度合作，共同探索用户实际需求，为客户提供更多的优秀的产品与解决方案，推动行业发展。</p>
			`,
			img_index: [13, 14]
		},
		{
			title: '我司 AGV 亮相动力总成工厂智能物流设备启用仪式',
			date: '2021/11/30',
			descr: '2021年11月29日 动力总成工厂隆重举行了立体库及智能物流设备的启用仪式。动力总成工厂全体领导班子成员、集团工程部杨斯淇总监到场参加，我司裕新科技总经理曹文强受邀参加了启用仪式。',
			html: `
				<p>11月29日，动力总成工厂隆重举行了立体库及智能物流设备的启用仪式。动力总成工厂全体领导班子成员、集团工程部杨斯淇总监到场参加，我司裕新科技总经理曹文强受邀参加了启用仪式。</p>
				<p>本次在动力总成工厂投入使用的是我司自主研发的牵引式 AGV，该 AGV 采用国际领先的激光导航技术，具有高精度、高质量、高效率的特点，大幅提高了物流工作的管理精度和工作效率，减少错投、漏投风险，提升动力总成工厂物流智能化水平。</p>
				<p>仪式上，肖云龙副书记和曹总共同为牵引式 AGV 戴上红花，宣布智能物流设备的正式投入使用。</p>
				<p>在未来的智能化转型升级工作中，大众物流&裕新科技将继续努力，以匠心求极致，以创新求发展，全力打造高端自主品牌，全面助力主机厂高质量跃迁发展。</p>
			`,
			img_index: [11, 12]
		},
		{
			title: '中国重汽济南商用车公司项目拓展喜报',
			date: '2021/11/29',
			descr: '2021年11月 公司业务拓展又传喜报。经中国重汽集团济南商用车有限公司书面确认，我司正式中标“产品件（支架、铸铁类）三方物流服务”项目。',
			html: `
				<p>2021年11月公司业务拓展又传喜报。经中国重汽集团济南商用车有限公司书面确认，我司正式中标“产品件（支架、铸铁类）三方物流服务”项目。</p>
				<p>此次中标是我司第一次进入重汽商用车物流服务体系，也是公司供应链业务一次里程碑式重要拓展。在此公司向胡总及公司商务团队做出的成绩表示祝贺，也希望公司在业务拓展方面继续开疆拓土，再创辉煌！</p>
			`,
			img_index: [9, 10]
		},
		{
			title: '【喜报】热烈祝贺我公司中标红旗繁荣工厂供应链服务项目',
			date: '2021/09/01',
			descr: '2021年09月 长春市大众物流装配有限责任公司以良好的信誉、强大技术实力和行业经验，成功中标“红旗繁荣工厂供应链服务”业务，今日首批员工已入厂培训。',
			html: `
				<p>长春市大众物流装配有限责任公司以良好的信誉、强大技术实力和行业经验，成功中标“红旗繁荣工厂供应链服务”业务，今日首批员工已入厂培训。</p>
				<p>在红旗繁荣工厂的未来运营中，大众物流将继续秉持着汽车产业网联化、智能化、共享化发展理念，探索扩大工业互联网等新技术应用领域，协助主机厂共同打造现代化标杆工厂。</p>
				<p>在此公司向商务团队做出的成绩表示祝贺，也希望公司不断扩大新的主机厂体系，继续智能化变更进程。</p>
			`,
			img_index: [7, 8]
		},
		
		{
			title: '公司拓展长城汽车河北保定工厂厂内供应链服务业务',
			date: '2021/02/07',
			descr: '2020年10月 公司拓展长城汽车河北保定工厂厂内供应链服务业务。长城汽车股份有限公司是中国规模最大的集体所有制汽车制造企业，也是国内首家在香港上市并融资33亿港元的汽车企业。公司以稳健发展而著称，经济实力雄厚，连续10余年创造高增长和盈利的业绩。公司发展至今，连续入选中国企业500强，中国机械500强，中国民营企业上市公司十强，河北省企业百强之首，成为最优秀的民族汽车品牌之一。',
			html: `
				<p>2020年10月 公司拓展长城汽车河北保定工厂厂内供应链服务业务。</p>
				<p>长城汽车股份有限公司是中国规模最大的集体所有制汽车制造企业，也是国内首家在香港上市并融资33亿港元的汽车企业。公司以稳健发展而著称，经济实力雄厚，连续10余年创造高增长和盈利的业绩。公司发展至今，连续入选中国企业500强，中国机械500强，中国民营企业上市公司十强，河北省企业百强之首，成为最优秀的民族汽车品牌之一。</p>
				<p>大众物流于2020年10月起为长城汽车河北保定工厂厂内供应链服务提供运输服务。由于我们持续稳定的出色服务能力，我司承接其保定工厂的内供应链服务。我们的项目管理团队已入驻客户工厂仓库，陆续开展工作。我们非常开心能被客户选择和认可，并一定会继续发扬大众物流可靠、创新、安全、高效的服务精神，与客户共赢！</p>
			`,
			img_index: [0]
		},
		{
			title: '公司拓展天际汽车长沙工厂厂内供应链服务业务，提供仓储管理系统',
			date: '2021/02/07',
			descr: '2020年10月，公司拓展天际汽车长沙工厂厂内供应链服务业务，提供仓储管理系统。',
			html: `
				<p>2020年10月，公司拓展天际汽车长沙工厂厂内供应链服务业务，提供仓储管理系统。</p>
				<p>天际汽车科技集团有限公司是集新能源汽车研发、生产、销售和服务于一体的高端出行科技企业。ENOVATE天际汽车秉承全球设计、顶尖品质、智能互联的品牌理念，致力于用创新科技去重构汽车的设计、品质与智能体验，不断颠覆对于汽车的想象，探寻未来绿色出行的无限可能，逐渐成为绿色智能出行的探索者和引领者。</p>
				<p>此次大众物流与天际汽车的合作充分体现了大众物流在供应链服务和物流软件服务上的技术实力。未来，大众物流将在科技研发上持续投入更多资源，充分利用数字化的各环节核心技术优势，不断优化业务流程，为客户提供高度专业的一体化行业应用解决方案，帮助客户快速实现业务目标。助力企业高效完成数字化转型升级之路，更好的服务社会创造价值。</p>
			`,
			img_index: [1]
		},
		{
			title: '公司获得国家级高新技术企业资质',
			date: '2021/02/07',
			descr: '2020年09月，大众物流荣膺由吉林省科技厅、吉林省财政厅、国家税务总局吉林省税务局联合颁发的国家级高新技术企业认定证书，科技研发实力与持续创新能力再获肯定。',
			html: `
				<p>2020年09月，大众物流荣膺由吉林省科技厅、吉林省财政厅、国家税务总局吉林省税务局联合颁发的国家级高新技术企业认定证书，科技研发实力与持续创新能力再获肯定。</p>
				<p>高新技术企业是指在国家颁布的《国家重点支持的高新技术领域》范围内，持续进行研究开发与技术成果转化，形成企业核心自主知识产权，并以此为基础开展经营活动的企业，是知识密集型、技术密集型的经济实体。国家级高新技术企业的资质认定门槛高、标准严、耗时长，对产品核心技术、科研创新制度、科技成果转化能力以及企业成长性等各项目的研判极其严苛。同时，高新技术企业也是相关部门重点支持的具有高成长性的企业，对于优化产业结构、提高企业竞争力有着重要意义。</p>
				<p>国家级“高新技术企业”认证，是对大众物流在科技研发创新领域杰出贡献的肯定，这是荣耀，更意味着责任和使命。</p>
				<p>自公司成立以来，大众物流依托长达十余载的丰富行业经验和深厚专业知识，在企业数字化转型方案落地、企业数字化管理方案等一系列实施方面成效卓然，加上对自身专业能力的不断建设，不断为客户创造价值，持续在数字化转型之路上帮助客户取得商业成功。</p>
				<p>大众物流时刻洞察行业需求本质，深挖行业客户信息化需求，坚持优化技术能力，提高服务质量，并持续对现有的产品和解决方案进行整合升级，从行业客户痛点和需求出发，着力打造差异化能力，满足不同层次客户不断升级的业务要求。大众物流深刻理解汽车物流领域的关键行业知识和技术，将助力所有客户把握机遇、提升竞争力。</p>
				<p>未来，大众物流将在科技研发上持续投入更多资源，充分利用数字化的各环节核心技术优势，不断优化业务流程，为客户提供高度专业的一体化行业应用解决方案，帮助客户快速实现业务目标，进一步推动自主研发、科技转化与创新发展的进程，致力于成为一流的物流信息技术服务商。助力企业高效完成数字化转型升级之路，更好的服务社会创造价值。</p>
			`,
			img_index: [2]
		},
		{
			title: '公司获得省级科技小巨人企业称号',
			date: '2021/02/07', 
			descr: '2020年09月， 公司荣获吉林省省级科技小巨人企业称号 。“吉林省科技小巨人企业”是由吉林省科技和信息化局根据市委、市政府《关于推进科技创新工程的实施意见》的精神以及《创新型企业和科技小巨人企业的专项申报指南》的要求，经过网上申报、网上评审、综合评审、网上公示等程序而认定的。',
			html: `
				<p>2020年09月， 公司荣获吉林省省级科技小巨人企业称号 。“吉林省科技小巨人企业”是由吉林省科技和信息化局根据市委、市政府《关于推进科技创新工程的实施意见》的精神以及《创新型企业和科技小巨人企业的专项申报指南》的要求，经过网上申报、网上评审、综合评审、网上公示等程序而认定的。</p>
				<p>大众物流是汽车智能物流技术应用的先行者、互联网+汽车物流模式的推动者以及汽车供应链生态圈的规划和组织者，致力于智能汽车物流供应链的建设，打造高科技物流企业新标杆。大众物流是由资深的供应链咨询管理、物流运营、信息技术专家组建的智慧型、科技型综合物流服务企业，下设有杭州裕新智能科技有限公司等运营实体及研发机构，专业从事物流软硬件开发和系统集成，专注于物流管理信息系统、智能化立体仓库及自动化设备制造，为客户提供端到端的全程一站式物流管理和定制化服务。公司坚持以市场为导向，积极推进企业技术创新工作，形成了多项拥有自主知识产权的产品和服务，有一定的经济规模和较好成长性。企业的发展最终获得了政府领导与专家的认可及肯定。</p>
				<p>未来大众物流将继续加大科研投入，持续提升科技创新能力，推进以企业为主题、市场为导向的企业技术创新体系建设，成为具有核心竞争力和领先地位的创新型企业。</p>
			`,
			img_index: [3]
		},
		{
			title: '全资子公司杭州裕新科技生产的AGV无人叉车正式亮相青岛解放',
			date: '2021/02/07',
			descr: '2020年08月, 全资子公司杭州裕新科技生产的AGV无人叉车正式亮相青岛解放。',
			html: `
				<p>2020年08月, 全资子公司杭州裕新科技生产的AGV无人叉车正式亮相青岛解放。</p>
				<p>作为与新科技主打产品，AGV无人叉车具有以下优点：</p>
				<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;无需地面施工，减少现场破坏；</p>
				<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;模拟真实人工作业，完美替代传统叉车；</p>
				<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;三重安全防护，有效杜绝安全事故可定制的车体，满足各种工作场景需求；</p>
				<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;开放的控制接口，可对接各类上层软件。</p>
				<p>此次能够与青岛解放合作，是源自青岛解放对裕新产品的认可。</p>
				<p>接下来陆续会有更多无人AGV产品投入现场使用。 让我们拭目以待。</p>
				
			`,
			img_index: [4]
		},
		{
			title: '绍兴天际汽车项目拓展喜报',
			date: '2021/02/07',
			descr: '2020 年 9 月 25 日大众物流业务拓展天际汽车绍兴工厂的物料运输外包业务。',
			html: `
				<p style="text-align:center;font-size:20px;">绍兴天际汽车项目拓展喜报</p>
				<p>2020 年大众物流业务拓展又传喜报。副总经理胡晓明及其商务团队积极拓展不断跟进，承接了天际汽车绍兴工厂的物料运输外包业务，现业务已正式运行。天际汽车绍兴乘用车生产基地为全智能化新能源整车生产基地，工厂焊、涂、总装车间均采用国内顶尖的自动化生产工艺，此次公司业务进入属于战略性拓展，下步公司将依托天际汽车现有业务，将智慧物流服务智能化工厂整体理念进一步尝试。</p>
				<p>公司对胡总在此次业务拓展中取得的成绩表示祝贺，愿商务团队再接再厉，再创辉煌！</p>
			`,
			img_index: [5, 6]
		}
	],


	//合作案例

	caseList: [{
			title: '天际汽车长沙基地',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/7948ED87733C3D077C1C44DFA75D5B5B.png',
			descr: '天际汽车长沙基地项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" style="width:800px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2020年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" style="width:179px">浙江省绍兴市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">120</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:179px">湖南省长沙市</td>
							<td dir="LTR" style="width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">5000㎡</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">天际汽车绍兴基地、天际汽车长沙基地</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">2</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">25</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">售后仓储服务、厂内物流服务、车轮总成装配服务</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">1</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">15</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">1200</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '长城汽车徐水工厂',
			date: '2021/01/05',
			// img: 'http://www.dzwlzpgs.com/Upload/news/7ACE2D277F70004D2E1B6E36773265FC.jpg',
			descr: '长城汽车徐水工厂项目基本境况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" style="width:800px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2020年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">河北省保定市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">80</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">长城汽车徐水工厂</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">上线配送服务</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">400</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '一汽集团红旗蔚山工厂',
			date: '2017/11/20',
			// img: 'http://www.dzwlzpgs.com/Upload/news/2108A1034CEF9BD428A6A45583F460D9.jpg',
			descr: '一汽集团红旗蔚山工厂项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" style="width:800px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2009年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">吉林省长春市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">692</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">48500</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽集团红旗蔚山工厂</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">51</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">一厂A线配送中心、一厂B线订单分割、二厂订单分割、二厂顺引中心</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">
							<p>5400</p>
							</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '一汽红旗仓储中心',
			date: '2017/11/20',
			// img: 'http://www.dzwlzpgs.com/Upload/news/463519B2E04F2DB0583097592FDC5847.png',
			descr: '一汽集团红旗蔚山工厂国产化异地供应商项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" style="width:800px">
					<tbody>
						<tr>
							<td colspan="4" style="height:43px; text-align:center; width:509px">&nbsp;基本情况</td>
							<td colspan="2" style="text-align:center; width:287px">&nbsp;相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2005年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">吉林省长春市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">112</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">38000</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽集团红旗蔚山工厂国产化异地供应商</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">23</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">11</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">为一汽集团红旗蔚山工厂365家国产化异地供应商提供仓储服务。</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">1800</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '一汽青岛解放汽车',
			date: '2017/11/20',
			// img: 'http://www.dzwlzpgs.com/Upload/news/920052EB7E5C6F916F430EB52F5F2B08.png',
			descr: '一汽青岛解放汽车有限公司项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2017年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">山东省青岛市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">531</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">28000</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽青岛解放汽车有限公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">10</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">48</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">总装车间配送服务、仓储服务</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">17</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">7800</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '一汽解放无锡柴油机厂',
			date: '2017/11/20',
			// img: 'http://www.dzwlzpgs.com/Upload/news/D7577F2D4B7F860425738E4A5EA9331C.jpg',
			descr: '一汽解放汽车有限公司无锡柴油机厂项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2017年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">山东省青岛市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">531</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">28000</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽青岛解放汽车有限公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">10</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">48</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">总装车间配送服务、仓储服务</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">17</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">7800</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '中车长春轨道客车',
			date: '2017/11/20',
			// img: 'http://www.dzwlzpgs.com/Upload/news/1D49BB04290337F56C6885A2C947CAAF.png',
			descr: '中车长春轨道客车股份有限公司高速动车组制造中心、客车制造中心项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2016年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">吉林省长春市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">391</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" style="width:409px">长春中车长客物流有限公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td colspan="3" dir="LTR" style="height:26px; width:409px">中车长春轨道客车股份有限公司高速动车组制造中心</td>
							<td dir="LTR" style="width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td colspan="3" dir="LTR" style="height:26px; width:409px">中车长春轨道客车股份有限公司客车制造中心</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">仓储物流配送服务、迁车服务、天车服务、工序外包服务</td>
							<td dir="LTR" style="width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">2000</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '一汽集团动力总成工厂',
			date: '2017/11/20',
			// img: 'http://www.dzwlzpgs.com/Upload/news/482F0B2D03D7FAF63C252B6E6ACF22E4.jpg',
			descr: '一汽集团动力总成工厂项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" class=".view auto} margin:0 table{" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2013年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">吉林省长春市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">172</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽集团动力总成工厂</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">1</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">11</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">中转库仓储服务、一/二/三厂内物流配送服务</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">1200</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '大众发动机',
			date: '2021/11/24',
			// img: 'http://www.dzwlzpgs.com/Upload/news/482F0B2D03D7FAF63C252B6E6ACF22E4.jpg',
			descr: '大众发动机项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" class=".view auto} margin:0 table{" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2021年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">吉林省长春市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">130</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">大众一汽发动机（大连）有限公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">大众发动机工厂内发动机零件物流配送与部分装配工作</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">700</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '一汽红旗繁荣工厂',
			date: '2021/11/24',
			// img: 'http://www.dzwlzpgs.com/Upload/news/482F0B2D03D7FAF63C252B6E6ACF22E4.jpg',
			descr: '一汽红旗繁荣工厂项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" class=".view auto} margin:0 table{" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2021年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">吉林省长春市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">126</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽集团红旗繁荣工厂</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">总装车间、焊装车间、涂装车间、冲压车间装配工作</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">3700</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '一汽丰田发动机',
			date: '2021/11/24',
			// img: 'http://www.dzwlzpgs.com/Upload/news/482F0B2D03D7FAF63C252B6E6ACF22E4.jpg',
			descr: '一汽丰田发动机项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" class=".view auto} margin:0 table{" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2021年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">吉林省长春市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">29</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽丰田发动机有限公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">发动机工厂内物流零件配送工作</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">240</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '青岛大众',
			date: '2021/11/24',
			// img: 'http://www.dzwlzpgs.com/Upload/news/482F0B2D03D7FAF63C252B6E6ACF22E4.jpg',
			descr: '青岛大众项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" class=".view auto} margin:0 table{" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2021年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">山东省青岛市即墨区</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">169</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">一汽大众汽车有限公司青岛分公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">青岛大众LOC1工段零件物流配送工作</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">1510</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '潍柴潍坊柴油机',
			date: '2021/11/24',
			// img: 'http://www.dzwlzpgs.com/Upload/news/482F0B2D03D7FAF63C252B6E6ACF22E4.jpg',
			descr: '潍柴潍坊柴油机项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" class=".view auto} margin:0 table{" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2021年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">山东省潍坊市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">97</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">潍柴（潍坊）中型柴油机有限公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">潍柴总一、总二、试车、成套四大车间的零件物流配送工作</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">880</td>
						</tr>
					</tbody>
				</table>
			`
		},
		{
			title: '潍柴重庆',
			date: '2021/11/24',
			// img: 'http://www.dzwlzpgs.com/Upload/news/482F0B2D03D7FAF63C252B6E6ACF22E4.jpg',
			descr: '潍柴重庆项目基本情况及相关数据',
			html: `
				<table align="center" border="1" cellpadding="0" cellspacing="0" class=".view auto} margin:0 table{" style="width:796px">
					<tbody>
						<tr>
							<td colspan="4" dir="LTR" style="height:43px; text-align:center; width:509px">基本情况</td>
							<td colspan="2" dir="LTR" style="text-align:center; width:287px">相关数据</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">成立时间</td>
							<td dir="LTR" rowspan="2" style="width:122px">2021年</td>
							<td dir="LTR" rowspan="2" style="width:108px">所在地</td>
							<td dir="LTR" rowspan="2" style="width:179px">重庆市</td>
							<td dir="LTR" style="width:147px">人员（人）</td>
							<td dir="LTR" style="width:140px">102</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">库房（㎡）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="2" style="height:52px; width:100px">服务客户</td>
							<td colspan="3" dir="LTR" rowspan="2" style="width:409px">潍柴（重庆）汽车有限公司</td>
							<td dir="LTR" style="width:147px">运输车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">叉车（台）</td>
							<td dir="LTR" style="width:140px">3</td>
						</tr>
						<tr>
							<td dir="LTR" rowspan="3" style="height:78px; width:100px">主要服务内容</td>
							<td colspan="3" dir="LTR" rowspan="3" style="width:409px">供应商零件仓储与内物流零件配送工作</td>
							<td dir="LTR" style="width:147px">电瓶车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">牵引车（台）</td>
							<td dir="LTR" style="width:140px">——</td>
						</tr>
						<tr>
							<td dir="LTR" style="height:26px; width:147px">年产值（万元）</td>
							<td dir="LTR" style="width:140px">810</td>
						</tr>
					</tbody>
				</table>
			`
		}
	]

}

module.exports = CONFIG
